// Zitro Property Management — i18n barrel
// Each locale lives in ./locales/{code}.js and is merged over IT so partial
// translations (DE / FR / RU) never break the UI. Historical structure of a
// single monolithic translations.js is preserved via this deep-merged export.

import it from "./locales/it";
import en from "./locales/en";
import de from "./locales/de";
import fr from "./locales/fr";
import ru from "./locales/ru";

// Deep merge — overlay `override` on top of `base`; arrays and primitives from
// override win, missing keys fall back to base.
const deepMerge = (base, override) => {
  if (Array.isArray(base) || typeof base !== "object" || base === null) {
    return override ?? base;
  }
  const out = { ...base };
  for (const k of Object.keys(override || {})) {
    out[k] = deepMerge(base[k], override[k]);
  }
  return out;
};

export const translations = {
  it,
  en,
  de: deepMerge(it, de),
  fr: deepMerge(it, fr),
  ru: deepMerge(it, ru),
};
